import * as React from 'react';
import { ISiteButtonImperativeActions } from '../../../SiteButton.types';
import SiteButtonContent from '../../SiteButtonContent';
import { SkinButtonProps } from '../SkinButton';

type BaseButtonSkinProps = SkinButtonProps & {
  skinsStyle: Record<string, string>;
};

const BaseButtonSkin: React.ForwardRefRenderFunction<
  ISiteButtonImperativeActions,
  BaseButtonSkinProps
> = (
  {
    wrapperProps,
    linkProps,
    elementType,
    skinsStyle,
    label,
    autoFocus,
    onFocus,
    onBlur,
  },
  ref,
) => {
  return (
    <div {...wrapperProps} className={skinsStyle.root}>
      <SiteButtonContent
        linkProps={linkProps}
        elementType={elementType}
        className={skinsStyle.link}
        autoFocus={autoFocus}
        onFocus={onFocus}
        onBlur={onBlur}
        ref={ref}
      >
        <span className={skinsStyle.label}>{label}</span>
      </SiteButtonContent>
    </div>
  );
};

export default React.forwardRef(BaseButtonSkin);
